import { compose, withState, withHandlers } from 'recompose';

const WithToggle = compose(
  withState('toggled', 'toggle', props => !!props.initialState),
  withHandlers({
    on: ({ toggle }) => () => toggle(true),
    off: ({ toggle }) => () => toggle(false),
    toggle: ({ toggle }) => () => toggle(current => !current),
  }),
);

export default WithToggle;



// WEBPACK FOOTER //
// ./src/app/hoc/WithToggle.js